<section>
  <div class="top-panel">
    <span class="top-panel titles" [ngClass]="{'sub-item-text': subItem}">{{title}}
      <div *ngIf="searchable" class="search-links">
        <span class="left-bracket">(</span>
        <a class="link-item Auto_google_link-{{rootType}}" (click)="updateLink('google')" href={{currentLink}} target="_blank"> Google</a>
        <span>&nbsp;</span>
        <a class="link-item Auto_pubmed_link-{{rootType}}" (click)="updateLink('pubmed')" href={{currentLink}} target="_blank"> Pubmed</a>
        <span>)</span>
      </div>
    </span>
  </div>

  <!--
    Note: since that the title here is associated with a search link, do not pass the tableTitle to <gen-dynamic-form-table>
          but display it in the top-panel in the local page
   -->
  <gen-dynamic-form-table
    [itemTitle]="itemTitle"
    [data]="filteredData"
    [formId]="formName"
    [formVertical]="vertical"
    [tableVertical]="tableVertical"
    [viewAsTable]="viewAsTable"
    [itemRequiredMessage]="'Required information missing'"
    [editMode]="true"
    [popupMode]="true"
    [showAddButton]="showAddButton"
    [showDeleteButton]="showDeleteButton"
    [prioritizeAvailable]="prioritizeAvailable"
    [schema]="schema"
    [listenToDataChange]="listenToDataChange"
    [updatedFieldsContextRef]="updatedItemFieldsContextRef"
    [itemValidationEventRef]="itemValidationEventRef"
    (itemDeletedEmitter)="deleteItem($event)"
    (itemAddEmitter)="addNewItem($event)"
    (itemUpdateEmitter)="updateContainedData($event)"
    [prioritizeTrackByField]="prioritizeTrackByField"
    [itemNgClassRef]="getCurationItemNgClass.bind(this)"
    [removeItemOnDeleteRef]="shouldRemoveItemOnDelete"
    [isItemDisabledRef]="isItemDisabled.bind(this)"
    [isItemEditModeRef]="isItemEditMode.bind(this)"
    [itemUpdateOnBlurRef]="itemUpdateOnBlur"
    [submitted] = "submitted"
    [canDeleteItemRef]="isItemDeletable.bind(this)"
    [disabled]="isReadOnlyMode.bind(this)()"
  ></gen-dynamic-form-table>

</section>
